module.exports = __webpack_public_path__ + "img/sin-imagen.12976ac6.png";